export default __webpack_public_path__ + "static/media/manage_subscriptions.1fefbf52.svg";